module.exports = __webpack_public_path__ + "images/experience_header.5db29567.jpg";